import { makeStyles } from '@material-ui/core'

const searchViewStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(4.8),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#F7F6FC',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: theme.spacing(1.6),
    paddingTop: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  label: {
    color: theme.palette.common.black,
  },
  searchContainer: {
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3.2),
    paddingTop: theme.spacing(1.6),
    paddingBottom: theme.spacing(1.6),
    backgroundColor: theme.palette.common.white,
  },
  buttonContainer: {
    marginTop: theme.spacing(3.2),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textField: {
    marginBottom: theme.spacing(2.4),
  },
  fontBold: {
    fontWeight: 600,
  },
}))

export default searchViewStyles
